<h2 class="centered-input" style="text-align: center; font-size: 2em; line-height: 1.5em">
  Vitajte v informačnom systéme na hodnotenie kvality na TUKE
</h2>
